'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reducers = require('../utils/reducers');

var getInitialState = function getInitialState() {
  return {
    listComment: (0, _reducers.getFetchSubState)('initial'),
    createComment: (0, _reducers.getFetchSubState)('initial'),
    editComment: (0, _reducers.getFetchSubState)('initial'),
    removeComment: (0, _reducers.getFetchSubState)('initial')
  };
};
var initialState = getInitialState();

var actionsMap = _extends({
  resetFetchSubState: function resetFetchSubState(state /*, action*/) {
    return _extends({}, state, getInitialState());
  }
}, (0, _reducers.fetchReducer)('listComment', { resultName: true }), (0, _reducers.fetchReducer)('createComment', { resultName: true }), (0, _reducers.fetchReducer)('editComment', { resultName: true }), (0, _reducers.fetchReducer)('removeComment', { resultName: true }));

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var reduceFn = actionsMap[action.type];
  if (!reduceFn) return state;
  return reduceFn(state, action);
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/reducers/comment.js
// module id = 514
// module chunks = 1